import React, { useState, useEffect } from 'react';
import { Ticket, ChevronDown, ExternalLink, Loader2, DownloadCloud } from 'lucide-react';

export const TicketChip = ({ t = {}, open, onClick, id }) => (
    <button onClick={onClick}
        className="mt-1 inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] transition-colors bg-slate-800 text-slate-300 hover:bg-slate-700"
        data-testid={`spark-user-tickets-${id}`}>
        <Ticket className="w-3 h-3" />
        <span>{t.total || 0} ticket</span>
        {t.total > 0 && <span className={t.open ? 'text-amber-300' : 'text-slate-500'}>· {t.open} aperti</span>}
        <ChevronDown className={`w-3 h-3 transition-transform ${open ? 'rotate-180' : ''}`} />
    </button>
);

export const TicketList = ({ email, api, id, onImported }) => {
    const [items, setItems] = useState(null);
    const [busy, setBusy] = useState(false);
    const [msg, setMsg] = useState('');
    const load = () => api(`/api/v1/admin/spark/users/${encodeURIComponent(email)}/tickets`).then(r => setItems(r.ok ? r.data.tickets : []));
    useEffect(() => { load(); }, [email, api]); // eslint-disable-line react-hooks/exhaustive-deps
    const importJira = async () => {
        setBusy(true); setMsg('');
        const r = await api(`/api/v1/admin/spark/users/${encodeURIComponent(email)}/import-jira`, { method: 'POST' });
        setMsg(r.ok ? `Trovati su Jira ${r.data.found}, importati ${r.data.imported} nuovi.` : (r.data.detail || 'Importazione non riuscita'));
        setBusy(false); load(); onImported && onImported();
    };
    const bar = (
        <div className="flex items-center gap-3 px-3 py-2">
            <button onClick={importJira} disabled={busy} className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-indigo-600 hover:bg-indigo-500 disabled:opacity-60 text-white text-[11px] transition-colors" data-testid={`spark-user-import-jira-${id}`}>
                {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <DownloadCloud className="w-3.5 h-3.5" />} Importa da Jira (ultimi 50)
            </button>
            {msg && <span className="text-[11px] text-slate-400" data-testid={`spark-user-import-msg-${id}`}>{msg}</span>}
        </div>
    );
    if (!items) return <div className="lg:col-span-4 flex items-center gap-2 text-xs text-slate-500 p-2"><Loader2 className="w-3.5 h-3.5 animate-spin" /> Caricamento ticket…</div>;
    return (
        <div className="lg:col-span-4 mt-1 rounded-lg border border-slate-800 bg-slate-950/60 divide-y divide-slate-800" data-testid={`spark-user-ticket-list-${id}`}>
            {bar}
            {items.length === 0 && <p className="p-3 text-xs text-slate-500">Nessun ticket.</p>}
            {items.map(t => (
                <a key={t.key} href={t.url} target="_blank" rel="noreferrer" className="flex items-center gap-3 px-3 py-2 text-xs hover:bg-slate-800/60 transition-colors" data-testid={`spark-user-ticket-${t.key}`}>
                    <span className="font-mono text-indigo-300 w-24 flex-shrink-0">{t.key}</span>
                    <span className="flex-1 truncate text-slate-200">{t.summary || '—'}</span>
                    <span className={`px-1.5 py-0.5 rounded text-[10px] ${t.closed ? 'bg-slate-800 text-slate-400' : 'bg-amber-500/15 text-amber-300'}`}>{t.status || '—'}</span>
                    <ExternalLink className="w-3.5 h-3.5 text-slate-500" />
                </a>
            ))}
        </div>
    );
};
